import { ActivitiBaseApi } from "./ActivitiBaseApi";
import { Methods } from "@newview/infrastructure";


export class ActivitiServiceApi extends ActivitiBaseApi {

  public get ControllerName(): any {
    return 'activiti'
  }


  /**
   * 流程部署
   * @param data
   */
  public buildProcessJson(data) {
    return this.send(data, "buildProcessJson", Methods.POST)
  }

  /**
   * 流程实例化
   * @param data
   * @constructor
   */
  public processInit(data) {
    return this.send(data, "ProcessInit", Methods.POST)
  }

  /**
   * 查询待办任务
   * @param userId 
   * @returns 
   */
  public getTaskList(userId:any="") {
    return this.send({ userId }, "getTaskList", Methods.GET);
  }

  /**
   * 查询待办任务
   * @param userId
   * @returns
   */
  public getTaskPoListST(userId:any="") {
    return this.send({ userId }, "getTaskPoListST", Methods.GET);
  }
  /**
   * 流程用户登录
   * @param userId
   * @returns
   */
  public loginAct(userId:any="") {
    return this.send({ userId }, "loginAct", Methods.GET);
  }


  /**
   * 石太查询待办任务
   * 排除质保资料相关业务
   * @param userId
   * @returns
   */
  public getTaskListPageST(userId:any="", index:any=1, size:any=15) {
    return this.send({ userId , index, size}, "getTaskListPageST", Methods.GET);
  }


  /**
   * 查询待办任务
   * @param userId
   * @returns
   */
  public getTaskListPage(userId:any="", index:any=1, size:any=15) {
    return this.send({ userId , index, size}, "getTaskListPage", Methods.GET);
  }

  /**
	   * 查询待办任务
	   * @param userId
	   * @returns
	   */
  public getTaskListAppPage(userId:any="",projectId:any="",flowCode:any="",startDate:any="",endDate:any="", index:any=1, size:any=15, txtName:any='') {
		return this.send({ userId ,projectId,flowCode,startDate,endDate, index, size, txtName}, "getTaskListAppPage", Methods.GET);
	  }

  /**
   * 获取下一节点信息
   */
  getNextNodeInfo(id,nodeId:any="") {
    return this.send({ taskId: id,nodeId:nodeId }, "getNextNodeInfo", Methods.GET);
  }

  /**
   * 获取当前节点信息
   */
  getNodeInfo(id,nodeId:any="") {
    return this.send({ taskId: id, nodeId:nodeId }, "getNodeUserInfo", Methods.GET);
  }

  /**
   * 获取流程审批记录
   * @param instanceId 
   * @returns 
   */
  getApplyStatus(instanceId) {
    return this.send({ instanceId }, "getApplyStatus", Methods.GET);
  }
  /**
   * 获取流程审批记录
   * @param instanceId
   * @returns
   */
  getApplyStatusV3(instanceId) {
    return this.send({ instanceId }, "getApplyStatusV3", Methods.GET);
  }

  getTaskVarinst(instanceId) {
    return this.send({ instanceId }, "getTaskVarinst", Methods.GET);
  }
  /**
   * 审批同意
   * @param processInstanceId 流程实例Id
   * @param opinion 审批意见
   * @param taskId 任务Id
   * @param userId 当前审批用户Id
   * @param userName 当前审批用户名称
   * @param handleUsers 下一步审批人Ids 例如 1,3,4,5
   * @returns 
   */
  passTask(processInstanceId, opinion, taskId, userId, userName, handleUsers = "",params:any ={}) {
    return this.send({
      ProcessInstanceId: processInstanceId,
      Opinion: opinion,
      TaskId: taskId,
      UserId: userId,
      UserName: userName,
      HandleUsers: handleUsers,
      FlowParams:params

    }, "passTask", Methods.POST);
  }

  /**
   * 审批退回
   * @param processInstanceId 流程实例Id
   * @param opinion 审批意见
   * @param taskId 任务Id
   * @param preNodeId 退回节点Id
   * @param userId 当前审批用户Id
   * @param userName 当前审批用户名称
   */
  returnTask(processInstanceId, opinion, taskId, preNodeId, userId, userName,AuditType="") {
    return this.send({
      ProcessInstanceId: processInstanceId,
      Opinion: opinion,
      TaskId: taskId,
      PreNodeId: preNodeId,
      UserId: userId,
      UserName: userName,
      auditType:AuditType
    }, "returnTask", Methods.POST);
  }


  JumpTask(ProcessInstanceId, preNodeId, params) {
    return this.send({
      ProcessInstanceId: ProcessInstanceId,
      PreNodeId: preNodeId,
      FlowParams: params
    }, "JumpTaskNode", Methods.POST);
  }

  /**
   * 获取能退回的节点
   * @param instanceId 
   */
  getReturnNodes(instanceId) {
    return this.send({ InstanceId: instanceId }, "getReturnNodes", Methods.GET)
  }

  /**
   * 已发起
   * @param page 
   * @param limit 
   * @param userId 
   * @returns 
   */
  myApplyList(userId, index:any=1, size:any=15) {
    return this.send({ userId, index, size }, "myApplyList", Methods.GET)
  }

  /**
   * 已发起
   * @param page
   * @param limit
   * @param userId
   * @returns
   */
  myApplyListPage(userId, index:any=1, size:any=15) {
    return this.send({ userId, index, size }, "myApplyListPage", Methods.GET)
  }

  /**
	   * 已发起
	   * @param page
	   * @param limit
	   * @param userId
	   * @returns
	   */
  myApplyListAppPage(userId:any="",projectId:any="",flowCode:any="",startDate:any="",endDate:any="", index:any=1, size:any=15, txtName:any='') {
    return this.send({ userId,projectId,flowCode,startDate,endDate, index, size, txtName}, "myApplyListAppPage", Methods.GET)
  }

  /**
   * 获取流程节点
   * @param params
   */
  getTaskStep(params) {
    return this.send(params, "getTaskStep", Methods.GET)
  }

  /**
   * 已处理
   * @param userId
   */
  hisWork(userId, index:any=1, size:any=15) {
    return this.send({ userId, index, size}, "hisWork", Methods.GET)
  }
  /**
   * 已处理
   * @param userId
   */
  hisWorkST(userId, index:any=1, size:any=15) {
    return this.send({ userId, index, size}, "hisWorkST", Methods.GET)
  }

  /**
   * 已处理
   * @param userId
   */
  hisWorkPage(userId, index:any=1, size:any=15) {
    return this.send({ userId, index, size}, "hisWorkPage", Methods.GET)
  }

  /**
	   * 已处理
	   * @param userId
	   */
  hisWorkAppPage(userId:any="",projectId:any="",flowCode:any="",startDate:any="",endDate:any="", index:any=1, size:any=15, txtName:any='') {
    return this.send({ userId,projectId,flowCode,startDate,endDate, index, size, txtName}, "hisWorkAppPage", Methods.GET)
  }


  /**
   * 删除用户任务
   * @param params
   */
  deleteTaskByUserId(params){
    return this.send(params, "deleteTaskByUserId", Methods.POST)
  }


  /**
   * 删除任务(根据业务数据key删除)
   * @param params
   */
  deleteTask(params){
    return this.send(params, "deleteTask", Methods.POST)
  }


  /**
   * 已阅读
   * @param TaskId 
   * @returns 
   */
  updateTask(TaskId){
    return this.send({TaskId}, "updateTask", Methods.POST)
  }

  /**
   * 拾取任务
   * @param ProcessInstanceId
   * @param HandleUsers(多人逗号隔开)
   */
  claimTask(ProcessInstanceId, HandleUsers){
    return this.send({ProcessInstanceId: ProcessInstanceId, HandleUsers: HandleUsers}, "claimTask", Methods.POST)
  }

  /**
   * 业务ID查询流程信息
   * @param ProcessKey 
   */
 public getTaskInfo(ProcessKey,BusinessKey){
    return this.send({ProcessKey:ProcessKey,BusinessKey:BusinessKey},"getTaskInfo",Methods.GET)
  }

  /**
   * 根据taskId查询任务信息
   * @param taskId
   */
  public getTaskById(taskId){
    return this.send({taskId:taskId},"getTaskById",Methods.GET)
  }

  /**
   * 
   * @param instanceId 
   */
  public getApplyStatusTwo(instanceId){
    return this.send({instanceId:instanceId},"getApplyStatusTwo",Methods.GET)
  }

  /**
   * 根据流程key获取流程设计详情
   * @param ProcessKey
   */
  public getProcessInfo(ProcessKey){
    return this.send({ProcessKey:ProcessKey},"getProcessInfo",Methods.GET)
  }
  /**
   * 根据流程key获取流程设计详情
   * @param ProcessKey
   */
  public getInstanceIdByKey(BusinessKeys){
    return this.send({BusinessKey:BusinessKeys},"getInstanceIdByKey",Methods.GET)
  }

  /**
   * 多节点跳转
   * @param ProcessInstanceId
   * @param preNodeId
   * @param params
   * @returns
   */
  JumpMultipleNodes( processInstanceId,taskId, preNodeId, opinion, userId, userName, handleUsers = "",params:any ={}) {
    return this.send({
      ProcessInstanceId: processInstanceId,
      TaskId: taskId,
      PreNodeId: preNodeId,
      Opinion: opinion,
      UserId: userId,
      UserName: userName,
      HandleUsers: handleUsers,
      FlowParams:params
    }, "JumpMultipleNodes", Methods.POST);
  }


  /**
   * 根据instanceId查询任务信息
   * @param instanceId
   */
  public getTaskByInstanceId(instanceId,userId:any=0){
    return this.send({instanceId:instanceId,userId:userId},"getTaskByInstanceId",Methods.GET)
  }


  /**
   * 获取节点扩展参数
   */
  public getNodeParams(id,nodeId:any="") {
    return this.send({ taskId: id,nodeId:nodeId }, "getNodeParams", Methods.GET);
  }

  /**
   * 同步审批信息到业务表（洛卢OA）
   */
  public arrangeData() {
    return this.send({ }, "arrangeData", Methods.GET);
  }

    /**
     * 计量流程步骤查询
     */
    public getJLTaskInfo(BusinessKeys, ProcessKey) {
        return this.send({BusinessKeys:BusinessKeys,ProcessKey:ProcessKey }, "getJLTaskInfo", Methods.GET);
    }

  /**
   * 获取流程节点审批人ID
   * @param instanceId
   * @returns
   */
  getNodeUserV2(flowKey, nodeId) {
    return this.send({ flowKey:flowKey, nodeId: nodeId }, "getNodeUserV2", Methods.GET);
  }

    /**
     * 批量删除流程实例
     * @param processInstanceIds 流程实例Ids
     */
    public batchDeleteTask(ProcessInstanceIds: any[]) {
        return this.send({ ProcessInstanceIds }, "batchDeleteTask", Methods.POST)

    }






}
